import { IconFileUpload } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { FileCaptureBlock as RenderFileCaptureBlock } from '../../templateRenderer/CaptureBlocks/FileCaptureBlock'
import { FileDisplayBlock as RenderFileDisplayBlock } from '../../templateRenderer/DisplayBlocks/FileDisplayBlock'
import { FileCaptureBlock, FileDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  SwitchField,
  TypeOption,
} from './_BaseBlockConfig'

import { AttachmentTablePreview } from '@/components/shared-components/AttachmentTablePreview'
import { FileUploadResult } from '@/hooks/useAttachmentUpload'
import { Role } from '@/modules/adminUsers/roles'

class Config extends BaseBlockConfig<FileCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'file' as const

  public override enableBlockToColumnDisplay = true

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Images & documents',
    icon: IconFileUpload,
    helpText: 'Upload images and documents',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'multiUpload',
      label: 'Enable Multi-upload',
      helpText: 'Whether to support uploading multiple files',
      field: SwitchField,
    },
    {
      name: 'acceptAll',
      label: 'Accept all file types',
      helpText: 'Whether to allow uploading any file type',
      field: SwitchField,
      roles: [Role.SuperAdmin],
    },
  ]

  public override mapFormValueToBlock(
    block: FileCaptureBlock,
    value: FileUploadResult[]
  ): FileCaptureBlock {
    return {
      ...block,
      fileList: value
        ?.map((v) => ({
          name: v.name,
          key: v.key,
          attachmentId: v.attachmentId,
        }))
        ?.filter((f) => !!f.attachmentId), // filter out empty attachments
    }
  }

  public override mapBlockToColumnDisplay(
    block: FileCaptureBlock
  ): React.ReactNode {
    return (
      <AttachmentTablePreview
        attachments={
          block.fileList?.map((f) => ({
            url: f.url,
            thumbailUrl: f.thumbnailUrl,
            alt: f.name,
          })) ?? []
        }
      />
    )
  }

  public override renderBlock(
    block: FileCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderFileCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(block: FileDisplayBlock): React.ReactNode {
    return <RenderFileDisplayBlock block={block} />
  }
}

export const FileCaptureBlockConfig = new Config()
